import * as React from 'react';
import {
    Typography,
    Box,
    Container,
    Button,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { centered_flex_box, main_button, sec_button } from '../../app/components/Styles';
import { CheckCircle, Description, Home } from '@mui/icons-material';
import moment from 'moment';
import { useEffect } from 'react';

export const OutboundSuccess = ({
    getOutbound,
    downloadOutboundReceipt,
    outbound,
    isLoading,
    roleBasePath,
}) => {
    const navigate = useNavigate();
    const { outboundId } = useParams();
    const location = useLocation();
    const [localOutbound, setLocalOutbound] = React.useState(location.state?.outbound || null);

    useEffect(() => {
        if (localOutbound) {
            return;
        }
        getOutbound(outboundId);
    }, [outboundId]);

    useEffect(() => {
        if (outbound?._id === outboundId) {
            setLocalOutbound(outbound);
        }
    }, [outbound, outboundId]);

    const displayOutbound = localOutbound || outbound;
    const totalPieces = displayOutbound?.products?.reduce(
        (acc, product) => acc + parseInt(product.quantity, 10),
        0
    ) || 0;

    return (
        <Container maxWidth="sm" sx={{ py: 4 }}>
            <Paper
                elevation={3}
                sx={{
                    p: { xs: 3, sm: 4 },
                    borderRadius: 3,
                    backgroundColor: 'white',
                }}
            >
                <Box sx={{ ...centered_flex_box, flexDirection: 'column', mb: 3 }}>
                    <CheckCircle sx={{ fontSize: 64, color: '#4caf50', mb: 1 }} />
                    <Typography variant="h4" textAlign="center" sx={{ color: 'var(--secColor)' }}>
                        Outbound Successful
                    </Typography>
                    <Typography variant="body1" textAlign="center" color="text.secondary" sx={{ mt: 1 }}>
                        Inventory has been sent outside Chainz.
                    </Typography>
                </Box>

                {isLoading && !displayOutbound ? (
                    <Box sx={{ ...centered_flex_box, py: 4 }}>
                        <CircularProgress sx={{ color: 'var(--secColor)' }} />
                    </Box>
                ) : displayOutbound ? (
                    <>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle2" color="text.secondary">Brand</Typography>
                            <Typography variant="body1" fontWeight="bold">{displayOutbound.brandName}</Typography>

                            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2 }}>Date</Typography>
                            <Typography variant="body1">
                                {moment(displayOutbound.createdAt).format('MMMM D, YYYY [at] h:mm A')}
                            </Typography>

                            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2 }}>Reason</Typography>
                            <Typography variant="body1">{displayOutbound.notes || '—'}</Typography>
                        </Box>

                        <TableContainer sx={{ mb: 3 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>SKU</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Product</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>QTY</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {displayOutbound.products?.map((product, idx) => (
                                        <TableRow key={`${product.sku}-${idx}`}>
                                            <TableCell>{product.sku || '—'}</TableCell>
                                            <TableCell>{product.name}</TableCell>
                                            <TableCell align="right">{product.quantity}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell colSpan={2} sx={{ fontWeight: 'bold' }}>Total</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{totalPieces}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Button
                            fullWidth
                            variant="contained"
                            sx={{ mb: 2, ...main_button }}
                            disabled={isLoading}
                            onClick={() => downloadOutboundReceipt(outboundId)}
                            startIcon={isLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : <Description />}
                        >
                            Download Outbound Receipt (PDF)
                        </Button>
                    </>
                ) : null}

                <Button
                    fullWidth
                    variant="outlined"
                    sx={sec_button}
                    onClick={() => navigate(roleBasePath)}
                    startIcon={<Home />}
                >
                    Back to Dashboard
                </Button>
            </Paper>
        </Container>
    );
};
